import React from 'react';
import {IonButton} from "@ionic/react";

interface PagingButtonsProps {
    totalPages: number;
    currentPage: number;
    onPageChange: (page: number) => void;
}

const PagingButtons: React.FC<PagingButtonsProps> = ({ totalPages, currentPage, onPageChange }) => {

    const renderPageNumbers = () => {
        const pageNumbers = [];
        const maxPageNumbersToShow = 5;

        if (totalPages <= maxPageNumbersToShow) {
            // If total pages are 5 or less, show all pages
            for (let i = 1; i <= totalPages; i++) {
                pageNumbers.push(
                    <IonButton
                        fill={i === currentPage ? 'solid' : 'outline'}
                        key={i}
                        onClick={() => onPageChange(i)}
                        disabled={i === currentPage}
                    >
                        {i}
                    </IonButton>
                );
            }
        } else {
            // More than 5 pages, show ellipsis
            let startPage = Math.max(1, currentPage - 1);
            let endPage = Math.min(totalPages, currentPage + 1);

            // Always show the first page
            pageNumbers.push(
                <IonButton
                    fill={1 === currentPage ? 'solid' : 'outline'}
                    key={1}
                    onClick={() => onPageChange(1)}
                    disabled={currentPage === 1}
                >
                    1
                </IonButton>
            );

            if (startPage > 2) {
                // Add ellipsis after the first page
                pageNumbers.push(<span key="start-ellipsis">...</span>);
            }

            // Render pages around the current page
            for (let i = startPage; i <= endPage; i++) {
                if (i > 1 && i < totalPages) {
                    pageNumbers.push(
                        <IonButton
                            fill={i === currentPage ? 'solid' : 'outline'}
                            key={i}
                            onClick={() => onPageChange(i)}
                            disabled={i === currentPage}
                        >
                            {i}
                        </IonButton>
                    );
                }
            }

            if (endPage < totalPages - 1) {
                // Add ellipsis before the last page
                pageNumbers.push(<span key="end-ellipsis">...</span>);
            }

            // Always show the last page
            pageNumbers.push(
                <IonButton
                    fill="outline"
                    key={totalPages}
                    onClick={() => onPageChange(totalPages)}
                    disabled={currentPage === totalPages}
                    className={currentPage === totalPages ? 'active' : ''}
                >
                    {totalPages}
                </IonButton>
            );
        }

        return pageNumbers;
    };

    return (
        <div className="paging-buttons">
            <IonButton
                fill="clear"
                onClick={() => onPageChange(1)}
                disabled={currentPage === 1}
            >
                &lt;&lt;
            </IonButton>
            {renderPageNumbers()}
            <IonButton
                fill="clear"
                onClick={() => onPageChange(totalPages)}
                disabled={currentPage === totalPages}
            >
                &gt;&gt;
            </IonButton>
        </div>
    );
};

export default PagingButtons;
